'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createStyled;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../emotion/index');

var emotion = _interopRequireWildcard(_index);

var _createEmotionStyled = require('../create-emotion-styled');

var _createEmotionStyled2 = _interopRequireDefault(_createEmotionStyled);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * A custom HOC that wraps the default createEmotionStyled to allow
 * for options, being passed through a custom argument.
 */


function createStyled(options) {
  return (0, _createEmotionStyled2.default)(emotion, _react2.default, options);
}